module.exports = "<div class=\"portrait-block\">\n    <h1>Bitte drehe das Gerät<br>in den Landscape-Modus.</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/portrait-block/portrait-block.component.html
// module id = ./src/app/components/portrait-block/portrait-block.component.html
// module chunks = main